import { useEffect, useState } from 'react'

export const useCountdown = (ticks: number) => {
  const [tick, setTick] = useState<number>(ticks)
  const [fired, setFired] = useState<boolean>(false)

  const reset = () => {
    setTick(ticks)
    setFired(false)
  }

  useEffect(() => {
    const id = setTimeout(() => {
      setTick(tick - 1)
      if (tick === 0) setFired(true)
    }, 1000)

    return () => clearTimeout(id)
  })

  return { tick, fired, reset }
}
